import Api from "@/services/Api";
import BaseApi from "../../../services/baseApi";
class Slider_se {
    constructor() {
        this.entity = 'slider';
    }

    delete(id) {
        return Api.delete(this.entity,id)
    }


    showById(id) {
            return BaseApi({requiresAtuh: true})({
                method: 'GET',
                url: '/private/'+this.entity+'/showImage/?id='+id,
                headers: {'Content-Type': 'application/json'},
                responseType: 'blob', // important
            }).then((response) => {
                const url = window.URL.createObjectURL(new Blob([response.data]));
                const link = document.createElement('a');
                link.href = url;
                link.setAttribute('download', id+'.jpg'); //or any other extension
                document.body.appendChild(link);
                link.click();
            });

    }

    getPage() {
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            url: '/private/'+this.entity+'/list/',
            headers: {'Content-Type': 'application/json'},
        })
    }



    save(description,file,id) {
        let formData = new FormData();
        formData.set("description",description)
        formData.set("file", file)
        formData.set("id", id)
        return BaseApi({requiresAtuh: true})({
            method: 'POST',
            data: formData,
            url: '/private/'+this.entity+'/fileUpload/',
            headers: {'Content-Type': 'application/json'},
        })
    }





}
export default new Slider_se();
